const developmentInteriorHero = {
  displayField: 'header',
  name: 'Development Interior Hero',
  description: '',
  fields: [
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'developmentInteriorHero',
    version: 2,
    updatedAt: '2023-08-28T07:45:56.859Z'
  }
};
export default developmentInteriorHero;